import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const studyRetirementComplementaryInfosFields: FieldInterface[] = [
  {
    key: 'activityRevenue',
    originKey: 'activity_revenue',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'base',
    originKey: 'base',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'complementaryRevenue',
    originKey: 'complementary_revenue',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'computed',
    originKey: 'computed',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
]

const studyRetirementComplementaryInfosRelations: RelationInterface[] = []

export {
  studyRetirementComplementaryInfosFields,
  studyRetirementComplementaryInfosRelations,
}
